import "./navbarLocation.css";
import Button from "../../Custom/Button/Button";

const NavbarLocation = ({ location, handleData, index }) => {
  return (
    <div className="wraper-navbar-location">
      {location.map((item, i) => {
        const { active, name } = item;
        return (
          <div
            className="location-button-many"
            key={i}
            onClick={() => handleData(item, index, i)}
          >
            <Button active={active}>{name}</Button>
          </div>
        );
      })}
    </div>
  );
};

export default NavbarLocation;
